function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.01 127.08",
    width: "118px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contact-us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donor-Portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "58.76 9.84 17.7 26.85 0.54 67.84 17.02 109.57 58.42 126.54 99.32 108.31 116.47 67.34 100.18 26.82 58.76 9.84",
    style: {
      fill: "none",
      stroke: "#ffd100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    points: "58.76 0.54 17.7 17.55 0.54 58.54 17.02 100.27 58.42 117.24 99.32 99.01 116.47 58.04 100.18 17.51 58.76 0.54",
    style: {
      fill: "none",
      stroke: "#c3d7ee"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M43.79,46.23a.85.85,0,0,1,0,1.12,5.55,5.55,0,0,0,0,7.3.85.85,0,0,1,0,1.12.69.69,0,0,1-.5.23.71.71,0,0,1-.51-.23,7.28,7.28,0,0,1,0-9.54A.66.66,0,0,1,43.79,46.23Zm-3.19.26a7.19,7.19,0,0,0,0,10.16.75.75,0,0,1,0,1.06.75.75,0,0,1-1.06,0,8.69,8.69,0,0,1,0-12.28.74.74,0,0,1,1.06,0A.75.75,0,0,1,40.6,46.49Zm35.7.64a6.42,6.42,0,0,1,0,9.08.73.73,0,0,1-.53.22.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06,4.93,4.93,0,0,0,0-7,.75.75,0,1,1,1.06-1.06Zm3.16-1.7a8.69,8.69,0,0,1,0,12.28.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06,7.19,7.19,0,0,0,0-10.16.75.75,0,0,1,0-1.06A.74.74,0,0,1,79.46,45.43Zm-17.71.32a.75.75,0,0,1,0-1.5h.75a.75.75,0,0,1,0,1.5Zm-5.25,0a.75.75,0,0,1,0-1.5h3a.75.75,0,0,1,0,1.5Zm3,33a3,3,0,1,1-3,3A3,3,0,0,1,59.5,78.75Zm0,4.5a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,59.5,83.25ZM69,42a3.3,3.3,0,0,1,3.3,3.3V83.7A3.3,3.3,0,0,1,69,87H50.05a3.3,3.3,0,0,1-3.3-3.3V45.3a3.3,3.3,0,0,1,3.3-3.3Zm-20.7,6V76.5h22.5V48Zm1.8-4.5a1.81,1.81,0,0,0-1.8,1.8v1.2h22.5V45.3A1.81,1.81,0,0,0,69,43.5ZM69,85.5a1.81,1.81,0,0,0,1.8-1.8V78H48.25v5.7a1.81,1.81,0,0,0,1.8,1.8Z",
    transform: "translate(-0.46 -0.46)",
    style: {
      fill: "#2774ae"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/icon-contact-us.1d8ac9d86db01602fe91ea034158f545.svg";
export { ForwardRef as ReactComponent };